// Servicio de autenticación del módulo administrador.
// Guarda el JWT y los datos del usuario en localStorage.

const API_URL = process.env.REACT_APP_API_URL;

const TOKEN_KEY = 'admin_token';
const USER_KEY = 'admin_user';

export const login = async (email, password) => {
  const response = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // El email se recorta (evita espacios del autocompletado); la contraseña se envía tal cual.
    body: JSON.stringify({ email: email.trim(), password }),
  });

  if (response.status === 401) {
    throw new Error('Credenciales inválidas');
  }
  if (!response.ok) {
    throw new Error('No se pudo iniciar sesión');
  }

  const data = await response.json();
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(
    USER_KEY,
    JSON.stringify({
      nombre: data.nombre,
      email: data.email,
      rol: data.rol,
      expiraEn: data.expiraEn,
    })
  );
  return data;
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getUsuario = () => {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  const usuario = getUsuario();
  if (!token || !usuario) return false;
  // Verificar expiración del token.
  if (usuario.expiraEn && new Date(usuario.expiraEn) <= new Date()) {
    logout();
    return false;
  }
  return true;
};
